export default "__VITE_PUBLIC_ASSET__534fbc05__"